import React, { Component } from "react";
import { Form } from 'semantic-ui-react';
import  Logo  from "./logo";
import trocaSenhaImg from "../img/esqueci-minha-senha-topo.png";
import { isUndefined } from "util";

class ResetSenhaSucesso extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: isUndefined(this.props.history.location.state) || isUndefined(this.props.history.location.state.passo)?"Você deve passar por todo o fluxo de Esqueci Minha Senha.":"",
      passo: isUndefined(this.props.history.location.state)?false:!isUndefined(this.props.history.location.state.passo),
    };

  }


  handleRedefinir = async e => {
    this.props.history.push("/");
  }

  render() {
    if(!this.state.passo) {
      this.props.history.push("/resetPassword");
    }
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <h5 className="card-title text-center margin-top">
              <img src={trocaSenhaImg} className="img-responsive troca-senha" alt="Esqueci Minha Senha"/>
            </h5>
            <Form  onSubmit={this.handleRedefinir} autoComplete="off">
            <br/><p>Você recebeu uma senha temporária no padrão: hcpa + data nascimento (ex.: hcpa301260).<br/><br/>Agora é necessário que você crie nova senha a partir desta senha temporária clicando no botão abaixo.</p>    

              <button id="btnRedefinirSenha" 
                      className="btn btn-primary btn-block margin-top-input text-uppercase" 
                      type="submit" 
                      disabled={this.state.mensagemSucesso ===""}
                      > Redefinir Senha
              </button>
              <Logo />
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetSenhaSucesso;
